export function prettyAmount(amount: number) {
  return Math.floor(amount);
}
